import { useState } from "react";
import { Sidebar, TopHeader, Footer } from "../components";

export const SecretaryLayout = (props) => {
  const [toggle, setToggle] = useState(false);
  return (
    <div className={`${toggle ? "" : "toggled"} page-wrapper doctris-theme`}>
      <Sidebar manuClass="sidebar-wrapper sidebar-dark" />
      <main className="page-content bg-light">
        <TopHeader toggle={toggle} setToggle={setToggle} />
        {props.children}
        <Footer />
      </main>
    </div>
  );
};
